@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Motivos (Não Venda)</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          <a class="btn btn-secondary btn_titulo" routerLink="/motivos-nao-venda-cadastro">Novo Motivo</a>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda"></th>
                <th class="tabela_borda">Motivo</th>
                <th class="text-center tabela_borda">Criado</th>
                <th class="text-center tabela_borda">Visita Efetiva</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let motivoNaoVenda of motivosNaoVenda; templateCacheSize: 0;">
                <td class="text-center tabela_acao">
                  <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarMotivo(motivoNaoVenda.id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="atualizarStatus(motivoNaoVenda.id)"></i>
                </td>
                <td class="tabela_borda">{{ motivoNaoVenda.name }}</td>
                <td class="text-center tabela_borda">{{ motivoNaoVenda.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="text-center tabela_borda">
                  @if (motivoNaoVenda.flag_visita_efetiva) {
                    Sim
                  }
                  @if (!motivoNaoVenda.flag_visita_efetiva) {
                    Não
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}
